module.exports = __webpack_public_path__ + "static/media/pauloEquipe.6de18fd6.jpg";